import { Routes } from '@angular/router';
import { LoginPageComponent } from './domains/login/pages/login.page';
import { authGuard } from './core/auth/auth.guard';
import { routeRestrictionGuard } from './core/guards/route-restriction.guard';
import { rootRedirectGuard } from './core/guards/root-redirect.guard';
import { PrivacyPolicyPageComponent } from './domains/legal/pages/privacy-policy/privacy-policy.page';

export const routes: Routes = [
  { path: '', canActivate: [rootRedirectGuard], children: [] },
  { path: 'login', component: LoginPageComponent, canActivate: [routeRestrictionGuard] },
  {
    path: 'form-builder',
    loadChildren: () =>
      import('./domains/dinamic-form/dinamic-form.module').then((m) => m.DinamicFormModule),
    data: { preload: true },
  },
  {
    path: 'reports',
    canActivate: [routeRestrictionGuard, authGuard],
    loadChildren: () => import('./domains/report/report.module').then((m) => m.ReportModule),
    data: { preload: true },
  },
  {
    path: 'playground',
    canActivate: [routeRestrictionGuard, authGuard],
    loadChildren: () =>
      import('./domains/playground/playground.module').then((m) => m.PlaygroundModule),
  },
  {
    path: '404',
    loadChildren: () =>
      import('./domains/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  { path: 'privacy-policy', component: PrivacyPolicyPageComponent },
  { path: '**', redirectTo: '/404' },
];
